import React, { Fragment, useEffect, useState } from 'react';
import { H2, Btn } from '../../../../AbstractElements';
import { Col, Input, Label, Row } from 'reactstrap';
import { NewAddress, ShippingMethodTxt, ShippingTo } from '../../../../Constant';
import Popup from '../../../Common/Popup/popup';
import AddressAdd from '../../../Rks-customer/AddressAdd';
import { getShippingAddress } from '../../../../CommonUrl';
import { getClientUrlDataToken } from '../../../../Utils/restUtils';

const AddressShipping = ({ details, setShippingMethod, shippingMethod, setShippingAddressId, continueInvoice, shippingAddressId }) => {
    const [isOpenAdd, setisOpenAdd] = useState(false);
    const [apiResponse, setapiResponse] = useState(null);

    useEffect(() => {
        if (apiResponse?.length > 0) {
            const defaultAddress = apiResponse.find(item => item.set_default === 'yes');
            if (defaultAddress) {
                setShippingAddressId(defaultAddress.id);
            } else {
                setShippingAddressId(apiResponse[0].id); // fallback to first item if no default
            }
        }
    }, [apiResponse]);

    useEffect(() => {
        fetchDashboardData();
        if (details.delivery_charge_applicable !== 'no') {
            setShippingMethod({
                type: 'normal',
                amount: details.normal_delivery_charge
            });
        }
    }, []);

    const fetchDashboardData = async () => {
        const response = await getClientUrlDataToken(getShippingAddress);
        setapiResponse(response?.data);
    }

    const handleModalAdd = () => {
        setisOpenAdd(!isOpenAdd);
    };

    return (
        <Fragment>
            <Col xl="6" sm="12">
                <Popup isOpen={isOpenAdd} toggler={handleModalAdd} title='Add New Address'>
                    <AddressAdd setisOpenAdd={setisOpenAdd} list={fetchDashboardData} />
                </Popup>
                <div className="checkout-details">
                    <div className="order-box">
                        <div className="checkbox-title">
                            <H2>{ShippingTo}</H2>
                        </div>
                        <div className="animate-chk">
                            <Row>
                                <Col>
                                    {apiResponse?.map((item) => {
                                        const inputId = `address-${item.id}`;
                                        return (
                                            <Label className="d-block" key={item.id} htmlFor={inputId}>
                                                <input
                                                    className="radio_animated"
                                                    id={inputId}
                                                    type="radio"
                                                    name="shipping-address"
                                                    onChange={() => setShippingAddressId(item.id)}
                                                    checked={shippingAddressId === item.id}
                                                />
                                                {item.address}, {item.street}, {item.city}, {item.state}, {item.country}, {item.postal_code}
                                            </Label>
                                        );
                                    })}

                                </Col>
                            </Row>
                        </div>
                        <div className='mt-2 d-flex'>
                            <Btn attrBtn={{ color: `outline-primary m-1 w-100`, onClick: () => handleModalAdd() }}>
                                {NewAddress}
                            </Btn>
                        </div>
                        {details?.delivery_charge_applicable !== 'no' &&
                            <>
                                <div className="title-box"></div>
                                <div className="checkbox-title mt-3">
                                    <H2>{ShippingMethodTxt}</H2>
                                </div>
                                <div className="animate-chk">
                                    <Row>
                                        <Col>
                                            <Label className="d-block" htmlFor="quick">
                                                <input
                                                    className="radio_animated"
                                                    id="quick"
                                                    type="radio"
                                                    name="shipping-method"
                                                    checked={shippingMethod.type === 'quick'}
                                                    onChange={() =>
                                                        setShippingMethod({
                                                            type: 'quick',
                                                            amount: details.quick_delivery_charge,
                                                        })
                                                    }
                                                />
                                                <strong>Quick Delivery</strong><br />
                                                <div style={{ marginLeft: '30px' }}>{details.quick_delivery_notes}</div>
                                                <div style={{ marginLeft: '30px' }}>B$ {details.quick_delivery_charge}</div>
                                            </Label>

                                            <Label className="d-block" htmlFor="normal">
                                                <input
                                                    className="radio_animated"
                                                    id="normal"
                                                    type="radio"
                                                    name="shipping-method"
                                                    checked={shippingMethod.type === 'normal'}
                                                    onChange={() =>
                                                        setShippingMethod({
                                                            type: 'normal',
                                                            amount: details.normal_delivery_charge,
                                                        })
                                                    }
                                                />
                                                <strong>Normal Delivery</strong><br />
                                                <div style={{ marginLeft: '30px' }}>{details.normal_delivery_notes}</div>
                                                <div style={{ marginLeft: '30px' }}>B$ {details.normal_delivery_charge}</div>
                                            </Label>

                                        </Col>
                                    </Row>
                                </div>
                            </>
                        }
                        <div className='mt-2 d-flex justify-content-between'>
                            <div className='btn btn-primary text-white me-2 text-capitalize w-100' onClick={() => continueInvoice()}>Pay Now</div>
                        </div>
                    </div>
                </div>
            </Col>
        </Fragment >
    )
}

export default AddressShipping